import { render } from "./definePassword.vue?vue&type=template&id=381b3e11&ts=true"
import script from "./definePassword.vue?vue&type=script&lang=ts"
export * from "./definePassword.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__